import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3174bea6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "post__container" }

import { toRefs } from "vue";
import PostItem from "@/components/PostItem.vue";
import { PostItemType } from "@/types/props";
import {
  EmitPositionType,
  EmitSizeType,
  EmitZIndexType,
  EmitIdType,
  EmitChangeDraggableStatusType,
  EmitSavePostType,
  EmitChangeTitle,
  EmitChangeContents,
} from "@/types/emits";

// Props

export default /*#__PURE__*/_defineComponent({
  props: {
    postItems: null
  },
  emits: [
  "change:size",
  "change:position",
  "focus:z-index",
  "delete:post",
  "change:draggableStatus",
  "save:post",
  "change:title",
  "change:contents",
],
  setup(__props: any, { emit: emits }) {

const props = __props as {
  postItems: PostItemType[];
}


const { postItems } = toRefs(props);

// Emits


function emitChangeSize(size: EmitSizeType) {
  emits("change:size", size);
}
function emitChangePosition(position: EmitPositionType) {
  emits("change:position", position);
}
function emitFocusZIndex(index: EmitZIndexType) {
  emits("focus:z-index", index);
}
function emitDeletePost(_id: EmitIdType) {
  emits("delete:post", _id);
}
function emitChangeDraggableStatus(
  draggableStatus: EmitChangeDraggableStatusType
) {
  emits("change:draggableStatus", draggableStatus);
}
function emitSavePost(index: EmitSavePostType) {
  emits("save:post", index);
}
function emitChangeTitle(titleData: EmitChangeTitle) {
  emits("change:title", titleData);
}
function emitChangeContents(contentsData: EmitChangeContents) {
  emits("change:contents", contentsData);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(postItems), (postItem, i) => {
      return (_openBlock(), _createBlock(PostItem, {
        key: postItem._id,
        postItem: postItem,
        i: i,
        "onChange:size": emitChangeSize,
        "onChange:position": emitChangePosition,
        "onFocus:zIndex": emitFocusZIndex,
        "onDelete:post": emitDeletePost,
        "onChange:draggableStatus": emitChangeDraggableStatus,
        "onSave:post": emitSavePost,
        "onChange:title": emitChangeTitle,
        "onChange:contents": emitChangeContents
      }, null, 8, ["postItem", "i"]))
    }), 128))
  ]))
}
}

})